module.exports = __webpack_public_path__ + "static/img/ninoredpie.0eea388f.svg";